module.exports = __webpack_public_path__ + "img/appstore.2e212c06.png";